var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import KitSerializer from "../rna-fish/KitSerializer";
var ManualProConsumerKitSerializer = /** @class */ (function () {
    function ManualProConsumerKitSerializer() {
        var _this = this;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setAmplifier = function (state) {
            _this.amplifierState = state;
        };
        this.setBuffers = function (state) {
            _this.buffersState = state;
        };
        this.serializeKit = function (comment, sampleType) {
            var buffers = [];
            var probeSetComponent = null;
            if (_this.probeSetState) {
                var scalePmol = _this.probeSetState.scale.valuePmol;
                probeSetComponent = {
                    _type: 'manual',
                    probeSet: KitSerializer
                        .serializeProbeSet(_this.probeSetState.organism, _this.probeSetState.target, _this.probeSetState.hcrAmplifier, _this.probeSetState.probeLotNumber),
                    scalePmol: scalePmol,
                    index: 1
                };
            }
            var amplifierComponent = null;
            var proBuffersComponent = null;
            var chromogenComponent = null;
            if (_this.amplifierState) {
                var scale = _this.amplifierState.scale;
                amplifierComponent = ManualProConsumerKitSerializer.serializeAmplifier(_this.amplifierState, scale);
                proBuffersComponent = {
                    _type: 'manualPro',
                    index: 2,
                    sampleTypeId: sampleType.id,
                    amplificationBufferScaleSlides: scale,
                    blockingSolutionScaleSlides: scale,
                    endogenousEnzymeScaleSlides: scale,
                    preHybridizationScaleSlides: 0,
                    hrpQuencherScaleSlides: scale,
                    bluingAgentScaleSlides: scale
                };
                buffers.push(proBuffersComponent);
                if (_this.amplifierState.chromogen.id !== 'NONE') {
                    chromogenComponent = {
                        chromogenId: _this.amplifierState.chromogen.id,
                        chromogenBufferId: _this.amplifierState.chromogen.bufferCompatibility.id,
                        chromogenScaleSlides: scale,
                        chromogenBufferScaleSlides: scale,
                        hematoxylinScaleSlides: scale,
                        index: 1
                    };
                }
            }
            var fishBuffersComponent = null;
            if (_this.buffersState) {
                fishBuffersComponent = KitSerializer.serializeBuffers(_this.buffersState);
                buffers.push(fishBuffersComponent);
            }
            return {
                '_type': 'bundle-of-kits',
                kit: {
                    sampleTypeId: sampleType.id,
                    protocolType: 'MANUAL',
                    kits: [
                        {
                            channel: 1,
                            config: 'Manual Pro',
                            probeSetComponents: probeSetComponent ? [probeSetComponent] : [],
                            amplifierComponents: amplifierComponent ? [amplifierComponent] : [],
                            buffersComponents: buffers,
                            chromogenComponents: chromogenComponent ? [chromogenComponent] : []
                        }
                    ],
                    comment: comment
                }
            };
        };
    }
    ManualProConsumerKitSerializer.serializeAmplifier = function (a, amplifyScale) {
        var ampComponent = {
            _type: 'pro',
            amplifierId: a.enzyme.amplifier.id,
            haptenId: a.enzyme.hapten.id,
            antiHapten1Id: a.enzyme.antiHapten1.id,
            tyramideHaptenId: a.enzyme.tyramideHapten.id,
            amplifierScaleSlides: amplifyScale,
            antiHapten1ScaleSlides: amplifyScale,
            tyramideHaptenScaleSlides: amplifyScale,
            prefilled: false,
            index: 1
        };
        if (a.enzyme.antiHapten2Hrp.id !== "NONE") {
            ampComponent = __assign(__assign({}, ampComponent), { antiHapten2HrpId: a.enzyme.antiHapten2Hrp.id, antiHapten2HrpScaleSlides: amplifyScale });
        }
        return ampComponent;
    };
    return ManualProConsumerKitSerializer;
}());
export default ManualProConsumerKitSerializer;
//# sourceMappingURL=ManualProConsumerKitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/bundle-of-kits/ManualProConsumerKitSerializer.js
// module id = 1082
// module chunks = 0